import { checkTypeValue } from 'helpers';

// To Check State Mounted or UnMounted
const initialState = {};

const removeTypeProperty = (obj) => {
  const tempObj = { ...obj };
  delete tempObj.type;
  return tempObj;
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }

  if (/mounted/g.test(actions.type.toLowerCase())) {
    return {
      ...state,
      ...removeTypeProperty(actions),
    };
  }

  return state;
};
